export default function Deepnosis() {
  return (
    <section
      id="hypnodelics"
      data-testid="hypnodelics-section"
      className="relative py-20 lg:py-28 bg-[#030303] border-t border-[#B49A6C]/10 overflow-hidden"
    >
      <div className="absolute inset-0 pattern-hypnotic-radial" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <p className="text-[10px] uppercase tracking-[0.45em] text-[#B49A6C] mb-12 flex items-center gap-4">
          <span className="h-px w-12 bg-[#B49A6C]/50" />
          Programa insignia · Deepnosis
        </p>

        <div className="grid lg:grid-cols-12 gap-16 lg:gap-20 items-center">
          {/* Right on desktop: image */}
          <div className="lg:col-span-6 lg:order-2 relative">
            <div
              className="absolute inset-0 -z-10 blur-3xl opacity-60"
              style={{
                background:
                  "radial-gradient(circle at center, rgba(217,205,168,0.22) 0%, transparent 65%)",
              }}
            />
            <div className="relative overflow-hidden ring-1 ring-[#B49A6C]/20 shadow-[0_30px_60px_rgba(0,0,0,0.7)]">
              <img
                src="/hypnodelics.png"
                alt="Deepnosis — Go Deep"
                data-testid="hypnodelics-image"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Left on desktop: text */}
          <div className="lg:col-span-6 lg:order-1">
            <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#E8E5DC] mb-3">
              <span className="italic text-metal">Deepnosis.</span>
            </h2>
            <p className="text-[10px] uppercase tracking-[0.4em] text-[#807C70] mb-10">
              Go Deep
            </p>

            <p className="text-base sm:text-lg text-[#A89F8E] leading-loose font-light tracking-wide">
              <span className="text-[#E8E5DC]">Deepnosis</span> es un programa
              insignia, único y exclusivo — que es exactamente lo que el nombre
              dice.
            </p>

            <div className="divider-metal my-10" />

            <p className="text-sm sm:text-base text-[#807C70] leading-loose font-light tracking-wide">
              Entérate de todo lo relacionado a{" "}
              <span className="text-[#E8E5DC]">Deepnosis</span> dentro de la
              plataforma. Unirte es{" "}
              <span className="text-[#E8E5DC]">gratis</span>.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
